import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { RouteDefinition } from './Eftpos';
import { createElement } from 'react';

export default function SubRouter(props: { routes?: RouteDefinition[] }) {
	const { routes } = props;

	const { path } = useRouteMatch();

	const prefix = path === '/' ? '' : path;

	return (
		<>
			<Switch>
				{routes?.map((route) => (
					<Route key={route.name} path={`${prefix}${route.route}`} exact={route.exact === true}>
						{createElement(route.component, {
							routes: route.routes,
						})}
					</Route>
				))}
				{routes && routes.length > 0 && (
					<Route key={`${prefix}/`} path={`${prefix}/`}>
						<Redirect to={`${prefix}${routes[0]?.route}`} />
					</Route>
				)}
			</Switch>
		</>
	);
}
